import {getAccessToken} from '@/service/authentication/authentication'; // 加载层

let variable = {

  /**
   *  获取运行环境
   */
  getEnv: () => process.env.NODE_ENV,

  /**
   *  是否生产环境
   */
  isProduction: () => process.env.NODE_ENV == 'production',

  /**
   *  是否测试环境
   */
  isBeta: () => process.env.NODE_ENV == 'beta',

  /**
   *  是否开发环境
   */
  isDev: () => process.env.NODE_ENV == 'development',

  /**
   *  获取服务地址
   */
  getServerUrl: () => process.env.VUE_APP_SECRET_BASE_API,
  /**
   *  商城地址
   */
  getMallAddress: () => process.env.VUE_APP_SECRET_MALL_URL,
  /**
   *  应用管理地址
   */
  getAppManageAddress: () => process.env.VUE_APP_SECRET_APP_MANAGE_URL,
  /**
   *  设备管理地址
   */
  getDevManageAddress: () => process.env.VUE_APP_SECRET_DEV_MANAGE_URL,

  /**
   * 获取文件
   * @param fileId 文件id
   * @returns {string}
   */
  getFile: (fileId) => {
    return `${process.env.VUE_APP_SECRET_BASE_NEW_API}esaleb-service-file/file/${fileId}?accessToken=${getAccessToken()}`
  }
}

const Config = {

  install(Vue, options) {

    Vue.prototype.$variable = variable

  }
};
export default Config

export {variable};